import {PersonalInfoAgreementVo} from '../../common/shared/api/nicolas/vo/PersonalInfoAgreementVo.interface';
import {AgreementContainer} from '../generated/types';
import {createAgreement} from './Agreement';

export function createPersonalInfoAgreement(
  agreement: PersonalInfoAgreementVo,
  isWebView: boolean
): AgreementContainer {
  return {
    itemList: agreement.agreement_personal_info_list.map(item =>
      createAgreement(item, isWebView)
    ),
  };
}
